<template>
  <div>
    <div class="layout-wrapper" v-bind:dir="active_lang.direction">
      <div class="container-full container">
        <slot></slot>
      </div>
    </div>
  </div>
</template>


<script>
import { mapState } from "vuex";

export default {
  name: "default-layout",
  computed: {
    ...mapState({
      active_lang: state => state.i18nmap.active_lang,
    }),
  },
};
</script>


<style scoped>
.container-full {
  width: 90%;
  padding: 10px;
  padding-top: 0px;
  margin-left: auto;
  margin-right: auto;
}

body,
#app,
.layout-wrapper {
  display: flex;
  flex-direction: column;
  height: 100vh;
}

.content-wrapper {
  flex: 1 0 auto;
  padding-bottom: 1rem;
}

</style>
